import { FilterChips } from 'shared/mui/Filter/FilterChips/FilterChips';

import { useGatewaysListFilterFields } from './hooks/useGatewaysListFilterFields';

export const GatewaysListFilterChips: React.FC = () => {
  const fields = useGatewaysListFilterFields();

  return <FilterChips fields={fields} />;
};
